/**
 * Password validation rules ported from the legacy DACIns SetupPasswordValidator().
 *
 * Requirements:
 *  - Between 12 and 20 characters
 *  - At least one lowercase letter
 *  - At least one uppercase letter
 *  - At least one number or special character
 */
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).{12,20}$/;

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 20;

export const PASSWORD_ERROR_MESSAGE =
  'Passwords must contain between 12 and 20 characters, both lower and uppercase letters, and at least one number or special character.';
